import React from "react";
import { Link as RouterLink } from "react-router-dom";
import "../assets/styles/PageStyles.scss";
import Button from "@mui/material/Button";

function Pages() {
  return (
    <div id="pages">
      <div className="pages-header" data-aos="fade-up">
        <span className="section-eyebrow">Explore</span>
        <h2 className="section-title">More from Goal Guru</h2>
        <p className="section-description">
          Plans, the blog, and the fine print — everything else in one place.
        </p>
      </div>
      <div className="items-container">
        <div className="page-wrapper">
          <div className="page-column">
            <h3>Features</h3>
            <p>
              See everything Goal Guru can do — Smart Alerts, Guru Vision AI,
              Live Predictions, Guru Summary, and more.
            </p>
            <Button
              variant="contained"
              className="read-more-btn"
              component={RouterLink}
              to="/features/"
            >
              View Features
            </Button>
          </div>
          <div className="page-column">
            <h3>Privacy Policy</h3>
            <p>
              Learn how we handle your data and protect your privacy. We are
              committed to ensuring your information is secure.
            </p>
            <Button
              variant="contained"
              className="read-more-btn"
              component={RouterLink}
              to="/privacy-policy/"
            >
              Read More
              <span className="visually-hidden"> of the Privacy Policy</span>
            </Button>
          </div>
          <div className="page-column">
            <h3>Terms & Conditions</h3>
            <p>
              Understand the rules and guidelines for using our services. Your
              agreement ensures a smooth experience for everyone.
            </p>
            <Button
              variant="contained"
              className="read-more-btn"
              component={RouterLink}
              to="/terms-conditions/"
            >
              Read More
              <span className="visually-hidden"> of the Terms &amp; Conditions</span>
            </Button>
          </div>
          <div className="page-column">
            <h3>Blog</h3>
            <p>
              Explore our latest articles on match analysis, tactics, and
              football data insights. Updated regularly.
            </p>
            <Button
              variant="contained"
              className="read-more-btn"
              component={RouterLink}
              to="/blog/"
            >
              View Blog
            </Button>
          </div>
          <div className="page-column">
            <h3>Pricing</h3>
            <p>
              Choose the right Goal Guru plan for you. Free, Striker, and Guru
              subscriptions available for live football alerts.
            </p>
            <Button
              variant="contained"
              className="read-more-btn"
              component={RouterLink}
              to="/pricing/"
            >
              View Pricing
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pages;
